import { Component, forwardRef, HostBinding, Injector, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DynamicComponentBase, IDynamicComponentConfig, RenderComponentBase } from '../../../dynamic-component';

@Component({
  selector: 'app-r-number',
  templateUrl: './r-number.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RNumberComponent),
      multi: true
    }
  ]
})
export class RNumberComponent extends RenderComponentBase {
  static KEY = 'r-d-number';

  // @HostBinding('style.float') float = 'left';

  constructor(injector: Injector) {
    super(injector);
  }

  configChange(config: IDynamicComponentConfig) {
    // if (typeof config.min !== 'number') {
    //   config.min = 0;
    // }
    // if (typeof config.max !== 'number') {
    //   config.max = 100;
    // }
    if (typeof config.step !== 'number') {
      config.step = 1;
    }
  }
}
